export default __webpack_public_path__ + "static/media/PPI-pools-013.c355d019.jpg";